"use client"

import type { PropsWithChildren } from "react"
import { useAuth } from "@/hooks"
import { useAsPath } from "@/hooks/useAsPath"
import type { TAuth } from "@/types"
import { authorized } from "@/utils"
import { Redirect } from "./Redirect"

type TProps = {
  permissions?: (auth: TAuth) => boolean
}

export function Guard({ children, permissions = authorized }: PropsWithChildren<TProps>) {
  const auth = useAuth()
  const asPath = useAsPath()

  if (!permissions(auth)) return <Redirect to="/login" from={asPath} ref={asPath} />

  return children
}
